define.alias("ember-composable-helpers/helpers/slice", "preview-grid/helpers/slice");